<template>
  <div class="card">
    <h2 class="project-page__description-title card__title">
      {{ $t('project.about_project') }}
    </h2>
    <div class="project-page__description-text" v-html="content" />
  </div>
</template>

<script setup>
defineProps({
  content: {
    type: String,
    required: true,
  },
});
</script>
